import { InsuranceDefinitionV2 } from 'domains/signupDirect/misc/insuranceOptions';

// @TODO SYNC WITH RYAN WHERE TO SAVE THIS
export const PRIVATE_PAY_EVALUATION_PRICE = 175;

export const OUT_OF_NETWORK_EVALUATION_PRICE = 88;

export const IN_NETWORK_EVALUATION_PRICE_CAP = 50;

export const getEvaluationPrice = ({
  insurance,
  isPrivatePay,
  isOutOfNetwork,
  chargeCommercialDepositsFeatureFlag,
}: {
  isPrivatePay?: boolean;
  insurance?: InsuranceDefinitionV2;
  isOutOfNetwork?: boolean;
  chargeCommercialDepositsFeatureFlag?: boolean;
}) => {

  
  if (isPrivatePay) return PRIVATE_PAY_EVALUATION_PRICE;

  // Medicare always has $0 deposit (no courtesy bill for out-of-network)
  if (insurance && insurance.insuranceType === 'Medicare') {
    return 0;
  }

  if (isOutOfNetwork) return OUT_OF_NETWORK_EVALUATION_PRICE;

  // charge 0 when commercial and feature flag is off
  if(insurance && insurance.insuranceType === 'Commercial' && insurance.networkStatus === 'In-network' && !chargeCommercialDepositsFeatureFlag) {
    return  0;
  }

  // dev-note:  context at https://expressable.slack.com/archives/C08GL3DEXPW/p1742311442867139
  // we are using the default deposit for in-network insurance that does not have estimates
  if (insurance) {
    // If we have estimates for this payer (not default estimates)
    if (!insurance.isDefaultEstimates) {
      // If we have an evaluation estimate, use it (capped at $50 if it's higher)
      if (insurance.averageEvalPatientResponsibility) {
        // If estimate is greater than $50, use $50 as the deposit
        // If estimate is less than $50, use the actual estimate
        return insurance.averageEvalPatientResponsibility > IN_NETWORK_EVALUATION_PRICE_CAP
          ? IN_NETWORK_EVALUATION_PRICE_CAP
          : insurance.averageEvalPatientResponsibility;
      }
    }

    // No specific estimates available, use $50 default
    return IN_NETWORK_EVALUATION_PRICE_CAP;
  }

  throw 'Didnt expect insurance to be undefined and also not private pay, one must be present';
};
